module.exports = __webpack_public_path__ + "img/lingdu.9e7006b7.jpg";